var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23216_283284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.3C6.83616 4.3 2.65002 8.48614 2.65002 13.65C2.65002 18.8138 6.83616 23 12 23C12.6002 23 13.1872 22.9434 13.756 22.8354M12 4.3V1M12 4.3C16.2102 4.3 19.7704 7.08267 20.9419 10.9092M9.80002 1H14.2M21.1619 4.95124L19.5119 3.30124L20.3369 4.12624M2.83815 4.95124L4.48815 3.30124L3.66315 4.12624M14.418 15.1008L12 13.65V9.5625",
    stroke: "#535A60",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0754 12.2017C21.3144 12.0927 21.5913 12.1045 21.8203 12.2331C22.0494 12.3616 22.2035 12.5921 22.2346 12.853L22.4349 14.5314C22.5188 15.2337 22.3767 15.9446 22.0301 16.5617L20.2648 19.7036L20.6316 19.9105L20.9515 19.341L21.5589 20.1692C21.8458 20.5616 21.8772 21.0854 21.6392 21.5092L20.502 23.5348C20.4201 23.6808 20.2673 23.773 20.1006 23.7781C19.9335 23.7832 19.775 23.7008 19.6844 23.56L18.6944 22.0277L15.0819 19.9972L13.2582 19.9487C13.091 19.9444 12.9381 19.8526 12.8557 19.7076C12.7732 19.5624 12.7727 19.3844 12.8548 19.2383L13.9923 17.2137C14.2305 16.7897 14.6949 16.5435 15.1795 16.585L16.2025 16.6721L15.8825 17.2415L16.249 17.4474L18.0143 14.3054C18.3612 13.6887 18.895 13.1974 19.5386 12.9034L21.0754 12.2017ZM18.3361 22.6571L17.56 23.264L14.6151 21.6094L14.73 20.6319L18.3361 22.6571ZM20.3119 14.9178C19.7245 14.588 18.9807 14.7964 18.6507 15.3839C18.3209 15.9714 18.5295 16.7152 19.1168 17.0451C19.7041 17.3752 20.4479 17.1666 20.778 16.5791C21.1079 15.9914 20.8992 15.248 20.3119 14.9178Z",
    fill: "#535A60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23216_283284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#535A60"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceIcon);
export default __webpack_public_path__ + "static/media/spaceIcon.bb22b614fc129f575f1d35a624344007.svg";
export { ForwardRef as ReactComponent };